/**
 * Разбор ссылок на встречу (заказ владельца 2026-10-12).
 *
 * <p>Встреча — группа с постоянной ссылкой: перешедший по ней вступает в группу и сразу входит в
 * её звонок. Ссылка приходит теми же путями, что ссылки на профиль и канал:
 * <ul>
 *   <li>`https://vrmsgr.pro/m/<секрет>` — то, что раздаёт создатель. Путь `/m/` сервером не
 *       занят, поэтому в браузере его отдаёт сам веб-клиент (`try_files … /index.html`), а на
 *       Android с приложением его открывает система (app link);
 *   <li>`svyaz://m/<секрет>` — диплинк в установленное приложение;
 *   <li>`https://vrmsgr.pro/?m=<секрет>` — запасная форма для веб-клиента.
 * </ul>
 *
 * <p>Ни React, ни состояния: правило «что считать ссылкой на встречу» проверяется тестом.
 */

/** Алфавит секрета — base64url, как его выдаёт сервер; потолок — длина колонки. */
const MEETING_TOKEN = /^[A-Za-z0-9_-]{1,64}$/;

function normalizeToken(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let t: string;
  try {
    t = decodeURIComponent(raw).trim();
  } catch {
    return null;
  }
  return MEETING_TOKEN.test(t) ? t : null;
}

function fromPathTail(tail: string): string | null {
  const m = tail.match(/^m\/([^/?#]+)\/?(?:[?#].*)?$/i);
  return m ? normalizeToken(m[1]) : null;
}

/**
 * Секрет встречи из ссылки, либо `null`, если это не ссылка на встречу.
 *
 * <p>Хост не проверяется — по той же причине, что у ссылок на профиль и канал: домен сайта
 * настраивается, а вреда нет — вход всё равно упирается в существующую встречу с этим секретом.
 */
export function meetingTokenFromLink(href: string | null | undefined): string | null {
  if (!href) return null;
  const raw = href.trim();
  if (raw.length === 0) return null;

  // `svyaz://m/…` — нестандартная схема: host у неё в разных движках разный, разбираем строкой.
  const scheme = raw.match(/^([a-z][a-z0-9+.-]*):\/\/(.*)$/i);
  if (scheme && !/^https?$/i.test(scheme[1])) {
    return fromPathTail(scheme[2].replace(/^\/+/, ''));
  }

  try {
    const url = new URL(raw);
    const fromQuery = normalizeToken(url.searchParams.get('m'));
    if (fromQuery) return fromQuery;
    return fromPathTail(url.pathname.replace(/^\/+/, ''));
  } catch {
    return null;
  }
}
